var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificadoDigital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20.346,
    viewBox: "0 0 15 20.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate-diploma",
    transform: "translate(-3.303 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3046",
    "data-name": "Grupo 3046",
    transform: "translate(3.303 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2237",
    "data-name": "Caminho 2237",
    d: "M16.623,19.729a.58.58,0,0,0,.664-.484l.137-.909a.565.565,0,0,1,.307-.422l.823-.411a.577.577,0,0,0,.254-.782l-.424-.82a.566.566,0,0,1,0-.517l.424-.819a.584.584,0,0,0,.036-.444.578.578,0,0,0-.291-.337l-.823-.411a.565.565,0,0,1-.307-.422l-.137-.909a.581.581,0,0,0-.664-.483l-.91.152a.564.564,0,0,1-.493-.16l-.647-.657a.579.579,0,0,0-.411-.171.585.585,0,0,0-.411.171l-.647.657a.561.561,0,0,1-.493.16l-.909-.15a.581.581,0,0,0-.664.483l-.136.909a.567.567,0,0,1-.307.422l-.824.411a.579.579,0,0,0-.254.782l.424.819a.561.561,0,0,1,0,.517l-.424.82a.579.579,0,0,0,.254.782l.824.411a.567.567,0,0,1,.307.422l.136.909a.581.581,0,0,0,.664.484l.909-.15a.558.558,0,0,1,.493.159l.647.655a.575.575,0,0,0,.822,0l.647-.655a.56.56,0,0,1,.493-.159Zm-2.462-.664a3.506,3.506,0,1,1,3.506-3.506A3.509,3.509,0,0,1,14.161,19.066Z",
    transform: "translate(-4.476 -2.046)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2238",
    "data-name": "Caminho 2238",
    d: "M14.566,12.991a3,3,0,1,0,3,3A3,3,0,0,0,14.566,12.991Z",
    transform: "translate(-4.88 -2.478)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2239",
    "data-name": "Caminho 2239",
    d: "M20.772,22.278l-1.631-1.631-.083.55a.971.971,0,0,1-.388.637.959.959,0,0,1-.722.172l-.911-.149a.181.181,0,0,0-.154.05l-.155.156,2.13,2.129a.31.31,0,0,0,.525-.162L19.576,23l1.037-.194a.306.306,0,0,0,.238-.214A.31.31,0,0,0,20.772,22.278Z",
    transform: "translate(-5.864 -3.939)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2240",
    "data-name": "Caminho 2240",
    d: "M12.561,21.854l-.939.153a.969.969,0,0,1-1.111-.812l-.083-.548L8.8,22.278a.31.31,0,0,0,.161.524L10,23l.194,1.035a.308.308,0,0,0,.523.163l2.129-2.13-.155-.157A.175.175,0,0,0,12.561,21.854Z",
    transform: "translate(-4.334 -3.939)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2241",
    "data-name": "Caminho 2241",
    d: "M14.5,4.217H6.868a.5.5,0,0,0,0,1H14.5a.5.5,0,0,0,0-1Z",
    transform: "translate(-3.888 -0.804)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2242",
    "data-name": "Caminho 2242",
    d: "M14.5,7.371H6.868a.5.5,0,1,0,0,.995H14.5a.5.5,0,1,0,0-.995Z",
    transform: "translate(-3.888 -1.406)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2243",
    "data-name": "Caminho 2243",
    d: "M8.619,16.36l-.376-.188a1.318,1.318,0,0,1-.265-.18H4.764a.4.4,0,0,1-.4-.4V1.46a.4.4,0,0,1,.4-.4h10.7a.4.4,0,0,1,.4.4V8.749A1.382,1.382,0,0,1,16.9,9.882l.016-8.422A1.46,1.46,0,0,0,15.46,0H4.764A1.463,1.463,0,0,0,3.3,1.461V15.595a1.463,1.463,0,0,0,1.461,1.461h3.16Z",
    transform: "translate(-3.303)",
    fill: "#64c2c8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificadoDigital);
export default __webpack_public_path__ + "static/media/certificadoDigital.872c7abf709ac4a3fd5b5accb233c8c1.svg";
export { ForwardRef as ReactComponent };